import { fromByteArray, toByteArray } from 'base64-js';

// Since the browser built-ins are not built for binary data, we need this:
export default class Base64Encoder {
  public static bytesToString(byteArray: Uint8Array): string {
    return fromByteArray(byteArray);
  }

  public static stringToBytes(stringValue: string): Uint8Array {
    return toByteArray(stringValue);
  }

}
